import React, { useContext, useState, useEffect } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Modal, Button } from "antd";
import DynamicTextFormatter from "./DynamicTextFormatter";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { RiWhatsappFill } from "react-icons/ri";
import { BiLink } from "react-icons/bi";
import _ from "lodash";
import "./Recommender.css";
import { Context } from "../App";
import copy from "copy-to-clipboard";
import { onecodeAPI } from "../AppConfig";
import { FeatureFlagContext } from "../FeatureFlagContext";

const getButtonToDisplay = (partnerLink, buttonToDisplay, isMyTeamsFlow, t, partnerDetails, copyToClipboard, whatsAppMessageTemplate, customer, oneCode) => {
  if(buttonToDisplay == "whatsapp") {
    return <>
      <div>
        <span style={{color: "#808080", fontSize: 14, fontWeight: 400}}>
        Please send this link to yourself via WhatsApp and click on it to start your application journey
        </span>
        <div>
        <Button size="large" 
        onClick={() => {
          // window.open(partnerLink)
          // window.open("https://apply.finnable.com/?utm_source=oncode&utm_medium=leadcampaign&utm_campaign=campaignname1&_branch_match_id=1037735816466019333&_branch_referrer=H4sIAAAAAAAAAzXIOw6AIBAA0dtYQmxNiJ12HsDGLLAqwi7I5%2F5GE7uZd9aayiDl7phBBxSQkgiOvfT1upc2r1PWY6u0ldiyQRXZRIvdK4TWNVIBwRqgBO7gz%2F9RfzAQ9g%2BOdy2uagAAAA%3D%3D", "_blank" )
          // applyToPartner(link);
          window?.Moengage?.track_event("whatsapp_brand_share_cta",{
            onecode:oneCode,
            id:partnerDetails?.id,
            brand_name:partnerDetails?.title
          });
            if (isMyTeamsFlow) {
              window.open(
                `https://wa.me/91${customer?.phoneNumber}?text=${whatsAppMessageTemplate}`
              );
            } else {
              window.open(
                `whatsapp://send?text=${whatsAppMessageTemplate}&phone=+91${customer?.phoneNumber}`
              );
            }
          }}
        style={{backgroundColor: "#00c34e", color: "#fff", borderRadius: 4, marginTop: 16}} block>
        {t("recommendation.ShareonWhatsapp")}
      </Button>
      {isMyTeamsFlow ? <Button size="large" onClick={() => {
        window?.Moengage?.track_event("copy_brand_link_cta",{
            onecode:oneCode,
            id:partnerDetails?.id,
            brand_name:partnerDetails?.title
          });
        copyToClipboard(whatsAppMessageTemplate)
      }} style={{backgroundColor: "#6C63FF", color: "#fff", borderRadius: 4, marginTop: 8}} block>
      Copy Link
      </Button> : <></>}
          </div>
      </div>
    </>
  } else {
    return <>
      <div>
        <span style={{color: "#808080", fontSize: 14, fontWeight: 400}}>
        Start your application journey with {partnerDetails?.title} by clicking on the button below

        </span>
        <div>
        <Button size="large" 
        onClick={() => {
          // applyToPartner("continue");
          window?.Moengage?.track_event("continue_brand_share_cta",{
            onecode:oneCode,
            id:partnerDetails?.id,
            brand_name:partnerDetails?.title
          });
          window.open(partnerLink, "_blank" )
            }}
        style={{backgroundColor: "#6C63FF", color: "#fff", borderRadius: 4, marginTop: 16}} block>
        Continue
      </Button>
      {isMyTeamsFlow ? <Button size="large" onClick={() => {
        window?.Moengage?.track_event("copy_brand_link_cta",{
            onecode:oneCode,
            id:partnerDetails?.id,
            brand_name:partnerDetails?.title
          });
        copyToClipboard(whatsAppMessageTemplate)
      }} style={{borderColor: "#6C63FF", color: "#6C63FF", borderRadius: 4, marginTop: 8}} block>
      Copy Link
      </Button> : <></>}
          </div>
      </div>
    </>
  }
}

export default function ApplyModal({
  isModalVisible,
  handleCancel,
  partnerDetails,
  customer,
  isBrandSpecific = false,
  buttonToDisplay="whatsapp",
  responseStatus,
  partnerLink,
}) {
  const { t } = useTranslation();
  const consumer = useContext(Context);
  const [searchParams, setSearchParams] = useSearchParams();
  const [lf5Url, setLf5Url] = useState("");
  const [lmsInternalStatus, setLmsInternalStatus] = useState(null);
  // const [responseStatus, setResponseStatus] = useState("");
  const [brandNotEligibleReasons, setBrandNotEligibleReasons] = useState([]);
  const [emailHandlePopup, setEmailHandlePopup] = useState(false);
  const [isEligibleModalVisible, setIsEligibleModalVisible] = useState(false);
  const [stateButtonType,setButtonType] = useState("whatsapp");


  const { oneCode } = useContext(FeatureFlagContext); 

  useEffect(() => {
    if(isModalVisible) {
      window?.Moengage?.track_event("brand_link_share_popup",{
        onecode:oneCode,
        id:partnerDetails?.id,
        brand_name:partnerDetails?.title
      });
    }
  }, [isModalVisible])

  const copyToClipboard = () => {
    const template = `${customer?.fullName},\n you can simply start your application process for ${partnerDetails?.title} by clicking the link down here.\n ${partnerLink} \n Note: This is a self generated link. Do not share it with anyone.`;
    copy(template);
    alert(`You have copied "${template}"`);
    // console.log(template, "template-----");
  };

  const whatsAppMessageTemplate = `${
    customer?.fullName
  },%0ayou can simply start your application process for ${
    partnerDetails?.title
  } by clicking the link down here.%0a${encodeURIComponent(
    partnerLink
  )}%0aNote: This is a self generated link. Do not share it with anyone.`; 
  return (
    <Modal
      visible={isModalVisible}
      onCancel={handleCancel}
      footer={null}
      centered={true}
      closable={true}
      bodyStyle={{
        border: "1px solid  #fff",
        justifySelf: "center",
        borderRadius: "10px",
        padding: "20px",
      }}
      width="90%"
      closeIcon={
        <CloseOutlined className="modalCloseBtn" />
      }
      maskStyle={{
        background: isBrandSpecific ? "rgba(0,0,0,0.7)" : null,
      }}
    >
      <p
        style={{
          textAlign: "center",
          fontSize: "15px",
          color: "#7D7D7D",
        }}
      >
        {responseStatus == 409 ? (
          <>
          <DynamicTextFormatter
            textString={t("recommendation.AlreadyApplied")}
            values={{
              __PartnerTitle__: { value: partnerDetails?.title },
            }}
          />
          </>
        ) : (
          <>
            <p></p>
          </>
        )}
      </p>

      {responseStatus !== 409 && (
        <div
          style={{
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
          }}
        ><img
            alt=""
            src={`https://onecode-asset.s3.ap-south-1.amazonaws.com/Brand_Logo_PNGs/${partnerDetails?.id}.png`}
            style={{ width: "230px", height: "100%" }}
          />
  
          <p style={{ fontWeight: "600", fontSize: 16, lineHeight: 1, paddingTop: 16 }}>Congratulations, {customer?.customerName}!</p>
          <div style={{ paddingBottom: 16}}>
            <div>
            <span>You are eligible for</span>
            </div>
            <div>
            <span>{partnerDetails?.title}</span>
            </div>
          </div>
          {getButtonToDisplay(partnerLink, buttonToDisplay, consumer.isMyTeamsFlow, t, partnerDetails, copyToClipboard, whatsAppMessageTemplate, customer, oneCode)}
        </div>
      )}
      {isEligibleModalVisible && (
        <Modal
          visible={isEligibleModalVisible}
          onCancel={() => setIsEligibleModalVisible(false)}
          footer={null}
          centered={true}
          closable={true}
          bodyStyle={{
            border: "1px solid  #fff",
            justifySelf: "center",
            borderRadius: "10px",
            padding: "20px",
          }}
          width="90%"
          closeIcon={<CloseOutlined className="modalCloseBtn" />}
        >
          <p
            style={{
              textAlign: "center",
              fontSize: "15px",
              color: "#7D7D7D",
              fontWeight: "bold",
            }}
          >
            Not Eligible
          </p>
          {brandNotEligibleReasons?.map((item, key) => (
            <p
              style={{
                textAlign: "center",
                fontSize: "15px",
                color: "#7D7D7D",
              }}
            >
              {key + 1}. {item}
            </p>
          ))}
        </Modal>
      )}
      {emailHandlePopup && (
        <Modal
          visible={emailHandlePopup}
          onCancel={() => setEmailHandlePopup(false)}
          footer={null}
          centered={true}
          closable={true}
          bodyStyle={{
            border: "1px solid  #fff",
            justifySelf: "center",
            borderRadius: "10px",
            padding: "20px",
          }}
          width="90%"
          closeIcon={<CloseOutlined className="modalCloseBtn" />}
        >
          <p
            style={{
              textAlign: "center",
              fontSize: "15px",
              color: "#7D7D7D",
              fontWeight: "bold",
            }}
          >
            Invalid Email ID!
          </p>

          <p
            style={{
              textAlign: "center",
              fontSize: "15px",
              color: "#7D7D7D",
            }}
          >
            Email already exists OR invalid characters/length/domain in Email,
            please ask your Business Consultant to update the email ID and apply
            again.
          </p>
          <div style={{ textAlign: "center" }}>
            <button
              onClick={() => {
                setEmailHandlePopup(false);
              }}
              style={{
                width: "90%",
                fontWeight: "500",
                backgroundColor: "#6C63FF",
                border: "none",
                fontSize: "14px",
                borderRadius: "5px",
                color: "#FFFFFF",
                padding: "5px",
              }}
            >
              Ok, got it.
            </button>
          </div>
        </Modal>
      )}
    </Modal>
  );
}
